// extracted by mini-css-extract-plugin
export default {"container":"page-title_container__2ogN9","text":"page-title_text__1wygw"};